import React from 'react';
import i18n from '@/i18n/config';
import { Chip } from '@heroui/react';
import { RiShieldUserLine } from '@remixicon/react';

export type RoleType = 'OWNER' | 'ADMIN' | 'EDITOR' | 'VIEWER' | 'MEMBER';

interface RoleChipProps {
  role: RoleType;
  size?: 'sm' | 'md' | 'lg';
  variant?: 'solid' | 'bordered' | 'light' | 'flat' | 'faded' | 'shadow' | 'dot';
  showIcon?: boolean;
}

const ROLE_CONFIG: Record<RoleType, { color: 'danger' | 'warning' | 'primary' | 'success'; label: string }> = {
  OWNER: { color: 'danger', label: i18n.t('copy.owner') },
  ADMIN: { color: 'success', label: i18n.t('enums.admin') },
  EDITOR: { color: 'primary', label: i18n.t('copy.editor') },
  VIEWER: { color: 'warning', label: i18n.t('copy.viewer') },
  MEMBER: { color: 'primary', label: i18n.t('copy.member') }
};

export function RoleChip({ role, size = 'sm', variant = 'flat', showIcon = true }: RoleChipProps) {
  const config = ROLE_CONFIG[role] || { color: 'default', label: role };

  return (
    <Chip
      color={config.color}
      size={size}
      variant={variant}
      startContent={showIcon ? <RiShieldUserLine className="h-3 w-3" /> : undefined}
    >
      <small>{config.label}</small>
    </Chip>
  );
}
